import { TableItem } from 'components/atoms';
import { Table } from 'components/organisms';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { IStatement } from 'services/statements/types';

const Errors = () => {
  const { t } = useTranslation();
  const { values } = useFormikContext<IStatement>();

  return (
    <Table
      id='AdminStatementErrors'
      size='compact'
      data={{
        nodes: (values.errors ?? []).map((e, k) => ({ ...e, id: k })),
      }}
      columns={[
        {
          label: t('enum.STATEMENT_STATUS.error'),
          renderCell: item => (
            <TableItem>
              <TableItem.Text
                text={
                  item.errorCode !== 'UNKNOW_ERROR'
                    ? t(`error-code.${item.errorCode}`)
                    : item.message
                }
              />
            </TableItem>
          ),
          resize: true,
        },
      ]}
    />
  );
};

export default Errors;
